var map = {
	"./geschichte/breslau-kommers.jpg": "65be",
	"./geschichte/grundung-1.jpg": "b6b2",
	"./geschichte/grundung-2.jpg": "ff42",
	"./geschichte/grundung-3.jpg": "e958",
	"./geschichte/merk-leute.jpg": "d923",
	"./geschichte/merk-poster.jpg": "bc7e",
	"./uber-uns/amicitia-old.jpg": "16c5",
	"./uber-uns/amicitia.jpg": "bde6",
	"./uber-uns/cathedral.jpg": "cacc",
	"./uber-uns/oppeln.jpg": "31fe",
	"./uber-uns/schlesien-karte.jpg": "7da8",
	"./uber-uns/technische-universitat.jpg": "f85b",
	"./zimmer-frei/zimmer-frei-1.jpg": "01c2",
	"./zimmer-frei/zimmer-frei-2.jpg": "6ae4",
	"./zimmer-frei/zimmer-frei-3.jpg": "f26d",
	"./zimmer-frei/zimmer-frei-4.jpg": "fe17",
	"./zimmer-frei/zimmer-frei-5.jpg": "74e5",
	"./zimmer-frei/zimmer-frei-6.jpg": "26fa",
	"./zimmer-frei/zimmer-frei-7.jpg": "c76e",
	"./zimmer-frei/zimmer-frei-8.jpg": "35c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "161e";